// extracted by mini-css-extract-plugin
module.exports = {"content":"groupScreen_content__6MuO2"};